import { SCHOOL_CLASS_NAMES } from "@repo/shared";

export type SchoolClassVariant = "7class" | "8class" | "8class-review";

// Maps a school class name to its UI variant by equality with SCHOOL_CLASS_NAMES.
// Equality (not substring) so a renamed class value fails loudly instead of silently
// falling through to a wrong variant.
export const getSchoolClassVariant = (name: string): SchoolClassVariant | undefined => {
  switch (name) {
    case SCHOOL_CLASS_NAMES.CLASS_7:
      return "7class";
    case SCHOOL_CLASS_NAMES.CLASS_8:
      return "8class";
    case SCHOOL_CLASS_NAMES.CLASS_8_REVIEW:
      return "8class-review";
    default:
      return undefined;
  }
};
